import { gql, useQuery } from '@apollo/client';
import {
  GameTypeEnum,
  OnlineOpponentsQuery,
  OnlineOpponentsQueryVariables,
} from 'graphql/types';

export const DEFAULT_RESULT_SIZE = 25;
export const DEFAULT_RESULT_SIZE_INCREMENT = 25;

export const POLL_INTERVAL = 5000;

export function useOnlineOpponents(
  sceneId?: string | null,
  gameType?: GameTypeEnum | null,
  resultSize?: number,
  searchInput?: string | null,
) {
  const { data, error, loading, refetch, startPolling, stopPolling } = useQuery<
    OnlineOpponentsQuery,
    OnlineOpponentsQueryVariables
  >(onlineOpponentsQuery, {
    variables: {
      input: {
        resultSize: resultSize ?? DEFAULT_RESULT_SIZE,
        searchInput,
        sceneId,
        gameType,
      },
    },
    pollInterval: POLL_INTERVAL,
  });

  return {
    error,
    loading,
    refetch,
    startPolling,
    stopPolling,
    opponents: data?.onlineOpponents.opponents,
    opponentCount: data?.onlineOpponents.numberOfAllOpponents,
  };
}

const onlineOpponentsQuery = gql`
  query OnlineOpponentsQuery($input: OnlineOpponentsInput!) {
    onlineOpponents(input: $input) {
      ...OnlineOpponents
    }
  }
  fragment OnlineOpponents on OnlineOpponents {
    opponents {
      ...OnlineOpponent
    }
    numberOfAllOpponents
  }
  fragment OnlineOpponent on OnlineOpponent {
    status
    user {
      id
      name
      email
      gameDifficulty
    }
  }
`;
